// packages/eden-form-parts/src/utils/context.js
import { createContext } from "react";
var ValidityStateContext = createContext();
var SmallContext = createContext();
var RangeInputContext = createContext();
var IdContext = createContext();
var DescribedByContext = createContext();
var TypeContext = createContext();
var DisabledContext = createContext();
export {
  DescribedByContext,
  DisabledContext,
  IdContext,
  RangeInputContext,
  SmallContext,
  TypeContext,
  ValidityStateContext
};
